import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

// import {
  
// } from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get organization members
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetOrganizationMembers = packet => {
  return {
    type: 'REQUEST_GET_ORGANIZATION_MEMBERS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetOrganizationMembersSuccess = data => ({
  type: 'RECEIVE_GET_ORGANIZATION_MEMBERS_SUCCESS',
  data
})

export const receiveGetOrganizationMembersFail = data => ({
  type: 'RECEIVE_GET_ORGANIZATION_MEMBERS_FAIL',
  data
})

export const tryToGetOrganizationMembers = packet => (dispatch, getState) => {

  dispatch(requestGetOrganizationMembers(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  let params = {};
  if(packet.startAfter){
    params.startAfter = packet.startAfter;
  }

  return fetch('/api/organizations/members/' + packet.id  + '?' + new URLSearchParams(params), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetOrganizationMembersSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetOrganizationMembersFail({errors:e, lastSubmit: packet}));
    })
}
